export default "__VITE_ASSET__C4H4E8DC__"